import { createContext } from 'react';

export const UserContext = createContext<{
  user: API.UserInfo | null | undefined;
  setUser: (user: API.UserInfo) => void;
  deviceInfo: API.DeviceInfo | null | undefined;
} | null>(null);
